import React from "react";
import { Link } from "react-router-dom";
import { Music, Trophy, Plane, Utensils, Newspaper, Drama, MoreHorizontal } from "lucide-react";

const ICONS = {
  music: Music,
  trophy: Trophy,
  plane: Plane,
  utensils: Utensils,
  newspaper: Newspaper,
  drama: Drama,
  more: MoreHorizontal,
};

export function CategoriesMini({ categories }) {
  return (
    <div className="grid grid-cols-4 gap-3 sm:grid-cols-7 lg:grid-cols-4 xl:grid-cols-7">
      {categories.map((c) => {
        const Icon = ICONS[c.icon] || MoreHorizontal;
        const to = c.name === "More" ? "/explore" : `/explore?category=${c.name}`;
        return (
          <Link
            key={c.name}
            to={to}
            data-testid={`home-category-${c.name.toLowerCase()}`}
            className="group flex flex-col items-center gap-2"
          >
            <span
              className={`flex h-14 w-14 items-center justify-center rounded-2xl ${c.bg} ${c.color} transition-transform duration-300 group-hover:-translate-y-1`}
            >
              <Icon className="h-6 w-6" />
            </span>
            <span className="text-xs font-medium text-muted-foreground group-hover:text-foreground">
              {c.name}
            </span>
          </Link>
        );
      })}
    </div>
  );
}

export default CategoriesMini;
